module.exports = __webpack_public_path__ + "img/uk.6f382b2d.png";